// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__00vCi","spinner":"LoadingSpinner_spinner__Q1vlO","spin":"LoadingSpinner_spin__01Hjx"};